/**
 * @generated SignedSource<<71cf301509264502e04d86b9dbdf58e7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpPriceDisplay_nftItem$data = {
  readonly mostRecentAuction: {
    readonly reservePrice: {
      readonly ether: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftPdpPriceDisplay_nftItem";
};
export type NftPdpPriceDisplay_nftItem$key = {
  readonly " $data"?: NftPdpPriceDisplay_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpPriceDisplay_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpPriceDisplay_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherAmount",
          "kind": "LinkedField",
          "name": "reservePrice",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ether",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "7a16b58bf7107c5e4c785ea7763c9b50";

export default node;
